export default __webpack_public_path__ + "static/media/new_vision.c12454a1.jpg";